import React, { Component } from "react";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import BlueButton from "../common/BlueButton"
export default class SuccessDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: this.props.title,
            message: this.props.message,
            open: this.props.didOpen
        }

    }

    componentWillReceiveProps(newProps) {
        if (newProps.didOpen === true) {
            this.setState({ open: true });
        }
    }


    handleClickOpen = () => {
        this.setState({ open: false });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        return (
            <div>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.state.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <BlueButton variant="contained" onClick={this.handleClose} >Ok</BlueButton>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

}
